import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'sbc-extended-exhibitor-entry',
  templateUrl: './extended-exhibitor-entry.component.html',
  styleUrls: [`./extended-exhibitor-entry.component.scss`],
})
export class ExtendedExhibitorEntryComponent {
  @Input() exhibitor!: ExhibitorEntry;
  @Input() relatedExhibitors!: ExhibitorEntry[];

  private _onCategorySelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() onCategorySelected: Observable<string> = this._onCategorySelected.asObservable();

  private _onExhibitorSelected: EventEmitter<ExhibitorEntry> = new EventEmitter<ExhibitorEntry>();
  @Output() onExhibitorSelected: Observable<ExhibitorEntry> = this._onExhibitorSelected.asObservable();

  selectCategory(categoryId: string) {
    this._onCategorySelected.next(categoryId);
  }

  selectExhibitor(exhibitor: ExhibitorEntry) {
    this._onExhibitorSelected.next(exhibitor);
  }
}
